import { SummaryRow } from '../../../Summary/SummaryRow';

interface Props {
  documentationType?: string;
  uploadedBy?: string;
}

export default function SponsorshipLetter({ documentationType, uploadedBy }: Props) {
  if (documentationType === undefined) {
    return <div>Uploaded by {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="documentationType"
        label="Sponsorship Type"
        fullLabel="What form of documentation do you have for your scholarship?"
        value={documentationType}
      />
    </>
  );
}
